"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconRadioWithIdWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconRadioWithIdWidget = /** @class */ (function (_super) {
    __extends(FalconRadioWithIdWidget, _super);
    function FalconRadioWithIdWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FalconRadioWithIdWidget.prototype.renderInputField = function () {
        return ((0, jsx_runtime_1.jsx)("div", { id: this.props.question.name, className: "input-group", children: _super.prototype.renderInputField.call(this) }));
    };
    return FalconRadioWithIdWidget;
}(plugin_journey_1.RadioQuestionWidget));
exports.FalconRadioWithIdWidget = FalconRadioWithIdWidget;
//# sourceMappingURL=FalconRadioWithIdWidget.js.map